/*
 * @Date: 2026-01-31 10:00:00
 * @Description: 搜索相关API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 热门搜索
  getHotSearch(data) {
    return request({
      url: "/search/getHotSearch?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 历史搜索
  getUserSearch(data) {
    return request({
      url: "/search/getUserSearch?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 删除历史搜索
  deleteUserSearch(data) {
    return request({
      url: "/search/deleteUserSearch",
      method: "post",
      data,
    });
  },
  // 课程搜索
  search(data) {
    return request({
      url: "/search/search",
      method: "post",
      data,
    });
  },
  // 课程详情
  getSearchCourseDetail(data) {
    return request({
      url: "/search/getSearchCourseDetail?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 搜索补全
  searchCompletion(data) {
    return request({
      url: "/search/searchCompletion?" + parameterChange(data),
      method: "get",
      data,
    });
  },
};
